import React from 'react';


const Footer = (props) => {
    return (
      <footer>
        <a href="https://www.sami.com.au/contact-us/">Contact SAMI</a>
      </footer>
    )
  }

export default Footer;
